import { $authHost } from "../../http";
import { 
    SERVICE_EXPENSE_GET_REQUEST, SERVICE_EXPENSE_GET_SUCCESS, SERVICE_EXPENSE_GET_ERROR, 
    SERVICE_EXPENSE_GET_BY_KEY_REQUEST, SERVICE_EXPENSE_GET_BY_KEY_SUCCESS, SERVICE_EXPENSE_GET_BY_KEY_ERROR, 
    SERVICE_EXPENSE_ADD_REQUEST, SERVICE_EXPENSE_ADD_SUCCESS, SERVICE_EXPENSE_ADD_ERROR, 
    SERVICE_EXPENSE_EDIT_REQUEST, SERVICE_EXPENSE_EDIT_SUCCESS, SERVICE_EXPENSE_EDIT_ERROR, 
    SERVICE_EXPENSE_DELETE_REQUEST, SERVICE_EXPENSE_DELETE_SUCCESS, SERVICE_EXPENSE_DELETE_ERROR
} from "../constants/serviceExpenseConstants";

export const getServiceExpenses = (args) => async (dispatch) => {
    try {
        dispatch({
            type: SERVICE_EXPENSE_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/serviceExpense/query",
            args || {},
            config,
        );
        dispatch({
            type: SERVICE_EXPENSE_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: SERVICE_EXPENSE_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getServiceExpenseByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: SERVICE_EXPENSE_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/serviceExpense/${id}`,
        );
        dispatch({
            type: SERVICE_EXPENSE_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: SERVICE_EXPENSE_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addServiceExpense = ({ name, summary, serviceId, reagentId }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: SERVICE_EXPENSE_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/serviceExpense",
            { name, summary, serviceId, reagentId },
            config,
        );
        dispatch(getServiceExpenses(queryArgs || {}));
        dispatch({
            type: SERVICE_EXPENSE_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: SERVICE_EXPENSE_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editServiceExpense = ({ id, name, summary, serviceId, reagentId }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: SERVICE_EXPENSE_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/serviceExpense",
            { id, name, summary, serviceId, reagentId },
            config,
        );
        dispatch(getServiceExpenses(queryArgs || {}));
        dispatch({
            type: SERVICE_EXPENSE_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: SERVICE_EXPENSE_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteServiceExpense = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: SERVICE_EXPENSE_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/serviceExpense",
            { data: { id } },
            config,
        );
        dispatch(getServiceExpenses(queryArgs || {}));
        dispatch({
            type: SERVICE_EXPENSE_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: SERVICE_EXPENSE_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

